"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APSwitch.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Switch = function Switch(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var input = props.input,
    onClick = props.onClick,
    customClass = props.customClass;
  var value = input.value;
  var modifier = {
    on: value
  };
  var text = value ? t("On") : t("Off");
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)('ap-switch', customClass);
  var handleClick = function handleClick() {
    onClick(value);
    input.onChange(!value);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('switch', modifier),
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('toggle', modifier)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('text', modifier)
  }, text));
};
var APSwitch = function APSwitch(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: Switch
  }, props));
};
APSwitch.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  name: _propTypes["default"].string.isRequired,
  customClass: _propTypes["default"].string
};
var _default = exports["default"] = APSwitch;